import { boronClient } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";

export const usePutEmailConfirmationToken = () =>
  useBoronMutation(async ({ token }: { token: string }) =>
    boronClient.PUT("/api/v1/settings/email/{token}", {
      params: {
        path: {
          token,
        },
      },
    }),
  );
